export default __webpack_public_path__ + "static/media/boothSetUp.d010b2f0.svg";